import { Directive, ElementRef, Input, OnInit, OnChanges, SimpleChanges, HostListener, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";

@Directive({ selector: '[get-route]' })
export class GetRouteDirective implements OnInit {

    @Input() route: string;
    @Input('get-route') disabled:boolean = false;
    @HostBinding('class.handcursor') isLink = false;

    @HostListener("click", ['$event']) onClick($event) {
        if (!this.route || this.disabled)
            return;

        const newRoute = this.route;
        const oldRoute = this.router.url;
        //var routeSegment: any = this.activeRoute.snapshot.root.firstChild.url && this.activeRoute.snapshot.root.firstChild.url.length > 0 ? this.activeRoute.snapshot.root.firstChild.url[0].path : "";
        const routeString: any = this.route.split('/')[1];
        if (this.route == '/'){
            this.router.navigateByUrl(this.route, { skipLocationChange: false })
            return    
        }
        if (!routeString) {
            return;
        }
        /*if (this.isRouteDefMatch(newRoute, oldRoute)) {
            const goTo = "/switch" + this.route;
            this.router.navigateByUrl(goTo, { skipLocationChange: true });
        } else {*/
            this.router.navigateByUrl(this.route, { skipLocationChange: false })
        //}

    }
    private el: ElementRef;
    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute,
        el: ElementRef
    ) {
        this.el = el
    }

    private hasMultipleSegments(urlString: string){
        return urlString.indexOf('/') > 1;
    }

    private numberOfSegments(urlString: string){
        return (urlString.match(new RegExp("/", "g")) || []).length; 
    }

    private isRouteDefMatch(newRoute: string, oldRoute: string){
        if (!this.hasMultipleSegments(newRoute)){
            return false;
        }
        if (this.numberOfSegments(newRoute) != this.numberOfSegments(oldRoute)){
            return false;
        }

        const newStructure = this.splitRouteByLastSlash(newRoute);
        const oldStructure = this.splitRouteByLastSlash(oldRoute);
        if (newStructure.root == oldStructure.root && newStructure.leaf && oldStructure.leaf){
            return true;
        }
        else{
            return false;
        }
    }

    private splitRouteByLastSlash(urlString: string){
        const rootSegment = urlString.slice(0, urlString.lastIndexOf('/'));
        const lastSlug = urlString.slice(urlString.lastIndexOf('/') + 1);
        return { root: rootSegment, leaf: lastSlug };
    }

    ngOnInit() {
        this.isLink = !this.disabled && this.route !== null && this.route !== "";
    }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-directives/get-route.directive.ts